import { useAuth } from "../context/AuthContext";
import Dashboard from "../pages/Dashboard";
import ManagerDashboard from "../pages/ManagerDashboard";

/**
 * Composant qui affiche le bon dashboard selon le type d'utilisateur :
 * - Super Admin : Dashboard complet avec toutes les statistiques et graphiques
 * - Manager : Mini dashboard avec Historique véhicules et Affectations
 */
const DashboardRouter = () => {
  const { user, hasPermission } = useAuth();

  // Si l'utilisateur est un Super Admin, afficher le dashboard complet
  if (user?.isSuperAdmin) {
    return <Dashboard />;
  }

  // Si l'utilisateur a accès au dashboard complet, l'afficher
  if (hasPermission("dashboard", "read")) {
    return <Dashboard />;
  }

  // Sinon, afficher le mini-dashboard manager
  return <ManagerDashboard />;
};

export default DashboardRouter;


